// import { useCallback, useEffect, useState } from "react";
// import apiClient from "../api/apiClient";

// type MetricsScope = "school" | "student" | "class";

// interface UseMetricsParams {
//   scope: MetricsScope;
//   schoolHash: string;
//   grade?: string;      // for class & student
//   studentId?: string; // for student
//   range?: "weekly" | "monthly"; // for school (or if backend supports others)
// }

// export function useMetrics({
//   scope,
//   schoolHash,
//   grade,
//   studentId,
//   range = "monthly",
// }: UseMetricsParams) {
//   const [data, setData] = useState<any>(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   const fetchMetrics = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       let url = "";
//       let params: any = {};

//       if (scope === "school") {
//         // /metrics/school/{schoolHash}?range=monthly
//         url = `/metrics/school/${schoolHash}`;
//         params.range = range;
//       }

//       if (scope === "class") {
//         // /metrics/class/{schoolHash}/{grade}
//         if (!grade) throw new Error("grade is required for class metrics");
//         url = `/metrics/class/${schoolHash}/${grade}`;
//       }

//       if (scope === "student") {
//         // /metrics/student/{schoolHash}/{grade}/{studentId}
//         if (!grade || !studentId) {
//           throw new Error("grade and studentId are required for student metrics");
//         }
//         url = `/metrics/student/${schoolHash}/${grade}/${studentId}`;
//       }

//       const res = await apiClient.get(url, { params });
//       setData(res.data);
//     } catch (err: any) {
//       console.error("Metrics API error:", err);
//       setError(
//         err?.response?.data?.message ||
//           err.message ||
//           "Failed to load metrics"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [scope, schoolHash, grade, studentId, range]);

//   useEffect(() => {
//     fetchMetrics();
//   }, [fetchMetrics]);

//   return {
//     data,
//     loading,
//     error,
//     refetch: fetchMetrics,
//   };
// }

import { useCallback, useEffect, useState } from "react";
import apiClient from "../api/apiClient";

type MetricsScope = "school" | "student" | "class";

interface UseMetricsParams {
  scope: MetricsScope;
  schoolHash?: string;
  grade?: string;
  studentId?: string;
  range?: "weekly" | "monthly";
  enabled?: boolean; // ✅ added
}

export function useMetrics({
  scope,
  schoolHash,
  grade,
  studentId,
  range = "monthly",
  enabled = true,
}: UseMetricsParams) {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMetrics = useCallback(async () => {
    if (!enabled) return; // ✅ guard
    if (!schoolHash) return; // prevent undefined URL

    let url = "";
    let params: any = {};

    // 🟢 SCHOOL
    if (scope === "school") {
      url = `/metrics/school/${schoolHash}`;
      
    }

    // 🟢 CLASS
    if (scope === "class") {
      if (!grade) return; // ✅ safe return instead of throw
      url = `/metrics/class/${schoolHash}/${grade}`;
    }

    // 🟢 STUDENT
    if (scope === "student") {
      if (!grade || !studentId) return; // ✅ safe return
      url = `/metrics/student/${schoolHash}/${grade}/${studentId}`;
    }

    if(range=== "monthly"){
      params.range = "monthly"
    }

    try {
      setLoading(true);
      setError(null);

      const res = await apiClient.get(url, { params });
      setData(res.data);
    } catch (err: any) {
      console.error("Metrics API error:", err);
      setError(
        err?.response?.data?.message ||
        err.message ||
        "Failed to load metrics"
      );
    } finally {
      setLoading(false);
    }
  }, [scope, schoolHash, grade, studentId, range, enabled]);

  useEffect(() => {
    if (!enabled) return;
    fetchMetrics();
  }, [fetchMetrics, enabled]);

  return {
    data,
    loading,
    error,
    refetch: fetchMetrics,
  };
}
